import { useIdentitiesContext } from '~/context/SubscriptionManagement/useIdentitiesContext';
import { useModalCoordinationContext } from '~/context/SubscriptionManagement/useModalCoordinationContext';

import ConnectedAccountsModal from './ConnectedAccountsModal';

/**
 * Consumer wrapper that feeds the prop-driven `ConnectedAccountsModal` — identity data from
 * `IdentitiesProvider` (root, so it survives OAuth round-trips on any tab) and open/close from
 * the global modal coordinator. Rendered on the General tab alongside the other account modals.
 */
export const ConnectedAccountsModalContainer = () => {
  const { identities, integrations, subscriberId } = useIdentitiesContext();
  const {
    global: { currentModal, handleCloseModal },
  } = useModalCoordinationContext();

  return (
    <ConnectedAccountsModal
      isOpen={currentModal === 'connected_accounts'}
      subscriberId={subscriberId}
      identities={identities}
      socialProviders={integrations}
      closeModal={handleCloseModal}
    />
  );
};
